import { render, staticRenderFns } from "./BudgetIssuesExcludedClassificationsComponent.vue?vue&type=template&id=4cc2def2&scoped=true"
import script from "./BudgetIssuesExcludedClassificationsComponent.vue?vue&type=script&lang=js"
export * from "./BudgetIssuesExcludedClassificationsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc2def2",
  null
  
)

export default component.exports